function createPrefetchViewport() {
  var done = /* @__PURE__ */ new Set();
  var nodes = /* @__PURE__ */ new Map();
  var io = null;
  var onPrefetch = null;
  function getObserver() {
    if (io) return io;
    io = new IntersectionObserver(function(entries) {
      var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
      try {
        for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var entry = _step.value;
          if (!entry.isIntersecting) continue;
          var href = nodes.get(entry.target);
          if (href && !done.has(href)) {
            done.add(href);
            onPrefetch === null || onPrefetch === void 0 ? void 0 : onPrefetch(href);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }, {
      threshold: 0.5
    });
    return io;
  }
  function start(prefetch) {
    onPrefetch = prefetch;
  }
  function observe(el, href) {
    nodes.set(el, href);
    getObserver().observe(el);
    return function() {
      nodes.delete(el);
      io === null || io === void 0 ? void 0 : io.unobserve(el);
      done.delete(href);
    };
  }
  return {
    start,
    observe,
    done,
    nodes
  };
}
var instance = null;
function startPrefetchViewport(prefetch) {
  if (!instance) instance = createPrefetchViewport();
  instance.start(prefetch);
}
function observePrefetchViewport(el, href) {
  if (!instance) instance = createPrefetchViewport();
  return instance.observe(el, href);
}
export {
  createPrefetchViewport,
  observePrefetchViewport,
  startPrefetchViewport
};
//# sourceMappingURL=prefetchViewport.js.map
